import style from "./PlanPicker.module.css";
import Icon from "@/ui/icon/Icon";
import { useTranslation } from "react-i18next";
import { formatPriceAmount } from "@/i18n/format";
import { useCurrentLanguage } from "@/i18n/useLocalized";

/**
 * The list of plan cards from the pricing page.
 *
 * Purely presentational: it knows which plan is selected and which one the user
 * is already on, and reports clicks. What selecting a plan then means — buying
 * it now, or switching at renewal — is the caller's business.
 */
function PlanPicker({ plans, selectedId, currentId, onSelect }) {
	const { t } = useTranslation();
	const language = useCurrentLanguage();

	// English writes the sign first: €14.99. Bosnian keeps it after: 14,9 €.
	const isEnglish = language === "en";
	const currency = <div className={style.currency}>€</div>;

	return (
		<div className={style.offersHolder}>
			{plans.map((plan) => (
				<div
					key={plan.id}
					className={`${style.offer} ${
						plan.preferred ? style.preferred : ""
					} ${selectedId === plan.id ? style.active : ""} ${
						currentId === plan.id ? style.current : ""
					}`}
					onClick={() => onSelect(plan.id)}
				>
					<div className={style.offerDetails}>
						<div className={style.checkbox}>
							{selectedId === plan.id && <Icon icon="fa-check" />}
						</div>
						<div className={style.offerInfo}>
							<h3>{t(plan.nameKey)}</h3>
							{currentId === plan.id ? (
								<div className={style.currentTag}>
									{t("payments:planCard.currentPlan")}
								</div>
							) : (
								plan.save != 0 && (
									<div className={style.saveTag}>
										{t("payments:planCard.discount", {
											percent: plan.save,
										})}
									</div>
								)
							)}
						</div>
					</div>
					<div className={style.priceHolder}>
						<div className={style.totalPrice}>
							{isEnglish && currency}
							<div className={style.amount}>
								{formatPriceAmount(plan.totalPrice, language)}
							</div>
							{!isEnglish && currency}
						</div>
						<div className={style.pricePerDay}>
							{isEnglish && currency}
							<div className={style.amount}>
								{formatPriceAmount(plan.pricePerDay, language)}
							</div>
							{!isEnglish && currency}
							<div className={style.sep}>
								<Icon icon="fa-slash-forward" />
							</div>
							<div className={style.period}>{t("payments:planCard.perDay")}</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}

export default PlanPicker;
